import CourseList from "../CourseList";

const TeacherDashboardPreparations = () => {
  return (
    <div>
      <CourseList />
    </div>
  );
};

export default TeacherDashboardPreparations;
